import { createRouter, createWebHistory } from "vue-router";
import ErrorView from "@/views/ErrorView.vue";
import DonationFormView from "@/views/DonationFormView.vue";
import DonationReturnView from "@/views/DonationReturnView.vue";
import { isShapeValidSlug } from "@/shared/utils/slug";
function requireSlugShape(to) {
    const raw = to.params.slug;
    const slug = Array.isArray(raw) ? raw[0] : raw;
    return isShapeValidSlug(slug) ? true : { name: "Error" };
}
/**
 * Shell-owned routes only. Feature routes (e.g. the consent module's /communications/* surfaces)
 * are injected at boot via router.addRoute() in main.ts, sourced from the ModuleRegistry.
 */
export const routes = [
    {
        path: "/forms/:slug",
        name: "DonationForm",
        component: DonationFormView,
        props: true,
        beforeEnter: requireSlugShape,
        meta: { titleKey: "donationForm.page.title", bareLayout: true },
    },
    {
        path: "/forms/:slug/return",
        name: "DonationReturn",
        component: DonationReturnView,
        props: true,
        beforeEnter: requireSlugShape,
        meta: { titleKey: "donationForm.return.page.title", bareLayout: true },
    },
    {
        path: "/error",
        name: "Error",
        component: ErrorView,
        meta: { titleKey: "error.title" },
    },
    {
        path: "/:pathMatch(.*)*",
        name: "NotFound",
        redirect: { name: "Error" },
    },
];
const router = createRouter({
    history: createWebHistory(),
    routes,
});
export default router;
